import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'giq-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  standalone: false,
})
export class InfoDialogComponent {
  dontShowAgain = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      content: string;
      showOkButton?: boolean;
      title?: string | undefined;
      okButtonText?: string | undefined;
      dontShowAgain?: boolean | undefined;
    },
    private dialogRef: MatDialogRef<InfoDialogComponent>
  ) {}

  close(button?: string | undefined): void {
    this.dialogRef.close({ dontShowAgain: this.dontShowAgain, button });
  }
}
